// This Version needs to be updated whenever there is a new release
export const CURRENT_VERSION = "V1.0.2";
